import React, { ChangeEventHandler, KeyboardEventHandler, useState } from 'react'
import PasswordStrengthBar, { PasswordFeedback } from 'react-password-strength-bar'
import { IconButton } from '@mui/joy'
import { FloatingLabelInput } from '@components/FloatingLabelInput'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

interface Props {
  showStrengthBar?: boolean
  value?: string
  placeholder?: string
  label?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
  onChangeScore?: (score: number, feedback: PasswordFeedback) => void
}

export const PasswordInput = ({
  showStrengthBar,
  value = '',
  placeholder,
  label,
  onChange,
  onKeyDown,
  onChangeScore,
}: Props) => {
  const [showValue, setShowValue] = useState(false)
  return (
    <>
      <FloatingLabelInput
        {...{ value, onChange, placeholder, label, onKeyDown }}
        type={!showValue ? 'password' : undefined}
        label={label ?? ''}
        endDecorator={
          <IconButton onClick={() => setShowValue(!showValue)}>
            {!showValue ? <EyeSlashIcon /> : <EyeIcon />}
          </IconButton>
        }
      />
      {!!showStrengthBar && (
        <PasswordStrengthBar
          scoreWords={['Muy débil', 'Débil', 'Normal', 'Buena', 'Óptima']}
          shortScoreWord={!value ? '' : 'Demasiado corta'}
          scoreWordStyle={{ fontSize: '0.875em' }}
          password={value}
          minLength={6} // Matches Firebase requirement
          onChangeScore={onChangeScore}
        />
      )}
    </>
  )
}
